module.exports = __webpack_public_path__ + "img/contact_04.6b795a45.png";